{
  const BaseModule = require('_base/base')

  const FONT_SIZE_RATIOS = {
    desktop: {
      Default: 1,
      S: 0.73,
      XL: 1.32,
      XXL: 2,
      XXXL: 4.5454,
      Factoid: 9,
    },
    mobile: {
      Default: 0.9821,
      S: 1,
      XL: 1.32,
      XXL: 2,
      XXXL: 4.5454,
      Factoid: 9,
    },
  }

  class LiftOutExample extends BaseModule {
    preInit() {
      this.isAffectingHeight = true
      this.modifier = Object
        .keys(FONT_SIZE_RATIOS.desktop)
        .find(size => this.$el.hasClass(`is__liftOut${size}`))
    }

    get isOnStickyPage() {
      return this.$el.closest('.js__page').hasClass('is__sticky')
    }

    get isMobile() {
      return window.application.isOnMobileScreen && window.application.hasMobileVersion
    }

    get screenModifier() {
      return this.isMobile ? 'mobile' : 'desktop'
    }

    get fontSizeRatio() {
      return FONT_SIZE_RATIOS[this.screenModifier][this.modifier]
    }

    get minFontSize() {
      if (this.isMobile) return this.isOnStickyPage ? 13 : 24

      return 18
    }

    get maxFontSize() {
      return 40
    }

    preCalculate() {
      this.fontSize = __.getShoutFontSize() * this.fontSizeRatio
      this.fontSize = Math.min(this.fontSize, this.maxFontSize * this.fontSizeRatio)
      this.fontSize = Math.max(this.fontSize, this.minFontSize)
    }

    preRender() {
      this.$el.css({
        'font-size': `${this.fontSize}px`,
        opacity: 1,
      })
    }
  }

  $('.example.is__liftOut').each(function() {
    new LiftOutExample($(this))
  })
}
